import { Children } from 'react';
import { ScopeFilters, ScopeFiltersOverflow } from './filters';
import { ScopeBarLeftContent } from './components/scope-bar-left-content';

export const geti18nStringTemplates = i18n => ({
  allEntity: entityTypeDisplayName => i18n.getString(_TL_('All {{entityType}}'), { entityType: entityTypeDisplayName }),
  filteredEntity: entityTypeDisplayName => i18n.getString(_TL_('Filtered {{entityType}}'), { entityType: entityTypeDisplayName }),
  subEntities: (entityName, subEntityTypeDisplayName, hasFilter) => {
    if (hasFilter) {
      return i18n.getString(
        _TL_('Filtered {{entityName}} {{subEntityType}}'),
        {
          entityName,
          subEntityType: subEntityTypeDisplayName,
        }
      );
    }
    return i18n.getString(
      _TL_('All {{entityName}} {{subEntityType}}'),
      {
        entityName,
        subEntityType: subEntityTypeDisplayName,
      }
    );
  },
  searchEntity: entityTypeDisplayName => i18n.getString(_TL_('Search {{entityType}}'), { entityType: entityTypeDisplayName }),
  loadingEntity: entityTypeDisplayName => i18n.getString(_TL_('Loading {{entityType}}...'), { entityType: entityTypeDisplayName }),
  Loading: i18n.getString(_TL_('Loading...')),
  noEntityFound: entityTypeDisplayName => i18n.getString(_TL_('No {{entityType}} found'), { entityType: entityTypeDisplayName }),
  NotFound: i18n.getString(_TL_('Not found')),
  subMenuTriggerLabel: entity =>
    i18n.getString(
      _TL_('View list of {{subEntityType}} for {{entityStatus}} {{entityType}}: {{[entityName]}}'),
      {
        entityType: entity.entityTypeDisplayName,
        entityStatus: entity.status,
        subEntityType: entity.subEntityTypeDisplayName,
        entityName: entity.name,
      }
    ),
});

export const getScopeFiltersChildComponent = children => Children.toArray(children).find(child =>
  child.type === ScopeFilters ||
  (child.type && (child.type.displayName === 'ScopeFilters' || child.type.name === 'ScopeFilters')));

export const getScopeFiltersOverflowChildComponent = children => Children.toArray(children).find(child =>
  child.type === ScopeFiltersOverflow ||
  (child.type && (child.type.displayName === 'ScopeFiltersOverflow' || child.type.name === 'ScopeFiltersOverflow')));

export const getScopeBarLeftContent = children => Children.toArray(children).find(child =>
  child.type === ScopeBarLeftContent ||
  (child.type && (child.type.displayName === 'ScopeBarLeftContent' || child.type.name === 'ScopeBarLeftContent')));

